export const useLocation = () => {
  // TODO use nextjs router
  return typeof window !== "undefined" ? window.location : { pathname: "/" }
}

// TODO implement matchPath as react-router-dom had it implemented (or refactor
// dependent code)
export const matchPath = () => null
// window.location.href.includes(pathname)
